// Notifications API
import api, { type AxiosResponse } from './client';
import type {
  Notification,
  NotificationPreferences,
  NotificationType,
  NotificationPriority,
  UnreadCount,
} from './types';

export const notificationsAPI = {
  // Get all notifications (paginated)
  getNotifications: (params?: {
    is_read?: boolean;
    type?: NotificationType;
    priority?: NotificationPriority;
    search?: string;
    page?: number;
    page_size?: number;
  }): Promise<AxiosResponse<{ count: number; results: Notification[] }>> =>
    api.get('/notifications/', { params }),

  // Get single notification
  getNotification: (id: number): Promise<AxiosResponse<Notification>> =>
    api.get(`/notifications/${id}/`),

  // Delete notification
  deleteNotification: (id: number): Promise<AxiosResponse<void>> =>
    api.delete(`/notifications/${id}/`),

  // Get unread count
  getUnreadCount: (): Promise<AxiosResponse<UnreadCount>> =>
    api.get('/notifications/unread_count/'),

  // Mark single notification as read
  markAsRead: (id: number): Promise<AxiosResponse<Notification>> =>
    api.post(`/notifications/${id}/mark_read/`),

  // Mark all notifications as read
  markAllAsRead: (): Promise<AxiosResponse<{ message: string; updated_count: number }>> =>
    api.post('/notifications/mark_all_read/'),

  // Mark selected notifications as read
  markSelectedAsRead: (notificationIds: number[]): Promise<AxiosResponse<{ message: string; updated_count: number }>> =>
    api.post('/notifications/mark_selected_read/', { notification_ids: notificationIds }),

  // Delete all read notifications
  deleteAllRead: (): Promise<AxiosResponse<{ message: string; deleted_count: number }>> =>
    api.post('/notifications/delete_all_read/'),

  // Get notification types
  getTypes: (): Promise<AxiosResponse<{ value: string; label: string }[]>> =>
    api.get('/notifications/types/'),

  // Get recent notifications (for TopBar dropdown)
  getRecent: (): Promise<AxiosResponse<Notification[]>> =>
    api.get('/notifications/recent/'),

  // Preferences
  getPreferences: (): Promise<AxiosResponse<NotificationPreferences>> =>
    api.get('/notifications/preferences/'),

  updatePreferences: (data: Partial<NotificationPreferences>): Promise<AxiosResponse<NotificationPreferences>> =>
    api.put('/notifications/preferences/', data),

  patchPreferences: (data: Partial<NotificationPreferences>): Promise<AxiosResponse<NotificationPreferences>> =>
    api.patch('/notifications/preferences/', data),
};
